import React, { useEffect } from 'react';
import BackgroundImage from './BackgroundImage';
import Service from './Service';
import DiagonalScrollComponent from './DiagonalScrollComponent';
import RealisationCard from './RealisationCard';
import Contact from './NotreGroupeComponent';
import Footer from './Footer';
import Video from './Video';
import TextOverlay from './TextOverlay';
import Professionalism from './Professionalism';
import ContactForm from './ContactForm';
import ContactText from './ContactText';

const HomePage = ({ scrollTo }) => {
  useEffect(() => {
    if (scrollTo) {
      const element = document.getElementById(scrollTo);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      } else {
        console.warn(`Element with ID ${scrollTo} not found.`);
      }
    }
  }, [scrollTo]);

  return (
    <div>
      <Video />
      <TextOverlay />
      <Professionalism />
      <BackgroundImage />
      <Service />
      <DiagonalScrollComponent />
      <RealisationCard />
      {/* <Contact /> */}
      <ContactText />
      <ContactForm />
      <Footer />
    </div>
  );
};

export default HomePage;
